import { isMl3App, isiOS } from './DeviceOptions';
import { sleep, versionCompare } from './Utils';
import { haflCallAPI } from '../maplifeCommon/login';
// import { checkCurrentLocationIsOkinawa } from '../modules/Helpers';

/**
 * getMl3AppVersion
 * Get the app version for iOS
 *   (todo: android getMl3AppVersion)
 */
let ml3AppVersion;
let gettingMl3AppVersion = false;
export const getMl3AppVersion = () =>
  new Promise(async resolve => {
    if (isMl3App && isiOS) {
      if (ml3AppVersion) {
        return resolve(ml3AppVersion);
      }

      let i = 0;
      const cacheML3AV = gettingMl3AppVersion;

      while (!ml3AppVersion) {
        i++;
        if (!cacheML3AV) {
          gettingMl3AppVersion = true;
          setTimeout(() => {
            window.location.href = 'native://getAppVersion()';
          }, 100);
        }
        await sleep();

        if (i > 3) {
          break;
        }
      }
    }

    resolve(ml3AppVersion);
  });
window.resultAppVersion = bundleNumber => {
  bundleNumber = bundleNumber.replace('MapLife/', '');
  ml3AppVersion = bundleNumber;
};
setTimeout(async () => {
  getMl3AppVersion();
}, 1000);

/**
 * NativeHideSplash
 * Hide iOS Splash screen
 */
export const NativeHideSplash = async () => {
  if (isMl3App && isiOS) {
    const version = await getMl3AppVersion();
    if (versionCompare(version, '3.0.5') >= 0) {
      window.location.href = 'native://hideSplash()';
      setTimeout(() => {
        window.location.href = 'native://hideSplash()';
      }, 300);
    }
  }
};
window.NativeHideSplash = NativeHideSplash;

/**
 * NativeGetDeviceToken
 * Get native device token. Currently only works in iOS
 */
let nativeDeviceToken;
export const NativeGetDeviceToken = () =>
  new Promise(async (resolve, reject) => {
    if (nativeDeviceToken) {
      return resolve(nativeDeviceToken);
    }

    if (!isMl3App) {
      return reject();
    }

    let i = 0;

    while (!nativeDeviceToken) {
      if (isiOS) {
        window.location.href = 'native://getDeviceToken()';
      } else if (window.maplife && window.maplife.getDeviceToken) {
        window.maplife.getDeviceToken();
      }
      i++;

      await sleep();

      if (i > 3) {
        return reject();
      }
    }

    resolve(nativeDeviceToken);
  });
window.resultDeviceToken = deviceToken => {
  nativeDeviceToken = deviceToken;
};

/**
 * FBNativeLoginStart
 */
export const FacebookMl3AppLogin = async () => {
  if (!isMl3App) {
    return;
  }

  if (isiOS) {
    const version = await getMl3AppVersion();
    if (versionCompare(version, '3.1.0') >= 0) {
      window.location.href = 'native://FBNativeLoginStart()';
      return;
    }
  }

  window.location.href = `https://www.facebook.com/dialog/oauth?client_id=924897417548499&response_type=token&scope=email,public_profile&redirect_uri=${
    window.location.origin
  }/ml3_facebook_redirect.php`;
};

window.FBNativeLoginSuccess = data => {
  data = JSON.parse(data);
  haflCallAPI(
    {
      ...data,
      id: data.account
    },
    true
  );
};
window.FBNativeLoginFailure = () => {
  console.log('Facebook Login Failure');
};

// NativeInitGeoFence
export const NativeInitGeoFence = async () => {
  const version = await getMl3AppVersion();
  if (isMl3App && versionCompare(version, '3.1.1') >= 0) {
    // ! ==============================
    // ! to uncomment
    // const isInOkinawa = await checkCurrentLocationIsOkinawa();
    // if (isInOkinawa) {
    window.location.href = 'native://initGeoFence';
    // }
    // ! ==============================
  }
};

let nativeGFList;
export const NativeGetGFList = async () => {
  if (isMl3App && isiOS) {
    const version = await getMl3AppVersion();
    if (versionCompare(version, '3.1.1') >= 0) {
      // get data here
      let i = 0;
      while (!nativeGFList) {
        i++;
        window.location.href = 'native://getGFlist';
        await sleep();
        if (i > 3) {
          break;
        }
      }
    }
  }

  if (!nativeGFList) {
    throw new Error();
  }

  // list = [
  //   { ads_area_id: 1, title: '1111', enabled: 1 },
  //   { ads_area_id: 2, title: '2222', enabled: 0 }
  // ];

  return nativeGFList;
};
window.resultGFlist = list => {
  try {
    if (list === '(null)') {
      list = '[]';
    }
    list = JSON.parse(list);
    if (list) {
      nativeGFList = list;
    }
  } catch (error) {
    console.log(error);
  }
};

export const NativeSetGF = (ads_area_id = '', enable = false) => {
  if (isMl3App && isiOS) {
    window.location.href = enable
      ? `native://setGFenable(${ads_area_id})`
      : `native://setGFdisable(${ads_area_id})`;
  }
};

// NativeClearNotificationsBadge
export const NativeClearNotificationsBadge = () => {
  if (isMl3App && isiOS) {
    window.location.href = 'native://clearNotificationsBadge()';
  }
};
